var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"k-chip-input-group"},_vm._l((_vm.chips),function(chip,index){return _c('k-chip-input',{key:`${chip[_vm.valueField]}[index][${index}]`,attrs:{"chip":chip,"value-field":_vm.valueField,"text-field":_vm.textField},on:{"remove":function($event){return _vm.removeChip(chip)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }